import React from 'react';
import { useDiceMarker } from './useDiceMarker';
import { useDiceSliderSound } from './useDiceSliderSound';
import { DiceResultCube } from './DiceResultCube';
import './diceTrack.css';

export const DiceTrack = ({ game, position, animating, resultClass }) => {
  const threshold = Number(game.target), round = game.round;
  const phase = useDiceMarker(round?.request_id, animating);
  const tick = useDiceSliderSound(game.muted, game.volume);
  const change = (event) => {
    const value = Math.min(game.direction === 'under' ? 98 : 99.98, Math.max(game.direction === 'under' ? .01 : 1.99, Number(event.target.value)));
    if (value === threshold) return;
    game.setTarget(value.toFixed(2)); tick(value);
  };
  const colors = { '--dice-position': `${Number.isFinite(threshold) ? threshold : 50}%`, '--dice-low': game.direction === 'over' ? '#f20a48' : '#00e701', '--dice-high': game.direction === 'over' ? '#00e701' : '#f20a48' };
  return <div className="dice-track dice-track-clean" data-testid="dice-track" style={colors}>
    <div className="dice-axis-labels" aria-hidden="true">{[0, 25, 50, 75, 100].map((value) => <span key={value} style={{ left: `${value}%` }}>{value}</span>)}</div>
    <div className="dice-rail" data-testid="dice-rail"><div className="dice-slider-runway">
      <div className="dice-range-color" aria-hidden="true" />
      <input type="range" min="0" max="100" step=".01" value={Number.isFinite(threshold) ? threshold : 50} disabled={game.busy || game.auto} onChange={change} aria-label="Dice roll threshold" aria-valuetext={`${threshold.toFixed(2)} · Roll ${game.direction}`} data-testid="dice-slider" />
      {round && <div className="dice-marker-runway"><div className="dice-cube-marker" style={{ left: `${position}%` }} data-testid="dice-roll-marker" data-result-position={position} data-state={phase} aria-hidden={phase === 'hidden' || phase === 'leaving'}>
        <DiceResultCube value={position} className={resultClass} testid="dice-result" animating={animating} />
      </div></div>}
    </div></div>
    <span className="dice-result-announcement" role="status" data-testid="dice-result-announcement">{round && !animating ? `Roll ${position.toFixed(2)}. ${round.win ? 'Win' : 'Loss'}.` : ''}</span>
  </div>;
};